import { FC, useId } from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
  color: #7a7afc;
`;

const AiSparkle: FC<{ className?: string; title?: string }> = ({
  className,
  title,
}) => {
  // useId() returns IDs containing colons (":r0:") which break url(#...) references
  // in some browsers. Sanitize to a CSS-safe form.
  const rawId = useId();
  const gradientId = `ai-sparkle-${rawId.replace(/[^a-zA-Z0-9_-]/g, '_')}`;
  const fill = `url(#${gradientId})`;
  return (
    <Svg
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      className={className}
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4a9eff" />
          <stop offset="100%" stopColor="#b06ab3" />
        </linearGradient>
      </defs>
      <path
        d="M14 2 C 14.6 7.2 16.8 9.4 22 10 C 16.8 10.6 14.6 12.8 14 18 C 13.4 12.8 11.2 10.6 6 10 C 11.2 9.4 13.4 7.2 14 2 Z"
        fill={fill}
      />
      <path
        d="M6 14 C 6.3 16.4 7.4 17.5 9.8 17.8 C 7.4 18.1 6.3 19.2 6 21.6 C 5.7 19.2 4.6 18.1 2.2 17.8 C 4.6 17.5 5.7 16.4 6 14 Z"
        fill={fill}
      />
    </Svg>
  );
};

export default AiSparkle;
